import type { TicketingSystem } from "@/domain/ticketing"

export const LINKS_DIVIDER = "|~|-|"

export const CHARACTERS_WARNING_THRESHOLD = 4500

export const CHARACTERS_LIMIT_REACHED_THRESHOLD = 5000

export const ANCHOR_ID = "bottom-anchor-kai-chat"

export const CLIENT_TOOLS = ["openTicketModal", "confirmQuestion"] as const

// Messages to Kai stay in English whatever the UI language: its instructions match them
export const TICKET_CREATION_CANCELED_MESSAGE = "Ticket creation canceled"

export const NO_GITHUB_REPOSITORY_MESSAGE =
  "No ticket was created: GitHub Issues is the only connected ticketing system, and none of these issues' projects has a GitHub code repository"

export const GITHUB_ISSUES_TURNED_OFF_MESSAGE =
  "No ticket was created: GitHub Issues is the only connected ticketing system, and GitHub issue creation is turned off for these issues' organizations"

export const KAI_TICKETING_SYSTEM_NAMES: Record<TicketingSystem, string> = {
  asana: "Asana",
  azure_boards: "Azure Boards",
  github: "GitHub Issues",
  jira: "Jira"
}
